const Contacts = ( $ ) => {
    const select = $('select');
    const input = $('.input input');

	if ( input.length ) {
		input.focus( function() {
			$( this ).parent().addClass( 'focus' );
		} );

		input.blur( function() {
			if ( $( this ).val().length === 0 ) {
				$( this ).parent().removeClass( 'focus' );
			}
		} );

		input.each( function() {
			if ( $( this ).val().length === 0 ) {
				$( this ).parent().removeClass( 'focus' );
			} else {
				$( this ).parent().addClass( 'focus' );
			}
		} );

	}
    select.selectric();
};

export default ( ( $ ) => $( Contacts ) )( jQuery );
